var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"left"},[_c('span',{staticClass:"tit-lf"}),_c('span',{staticClass:"title-color"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"rig"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }